import { render } from "./TreeSelectCustomInput.vue?vue&type=template&id=2ddb8861"
import script from "./TreeSelectCustomInput.vue?vue&type=script&lang=js"
export * from "./TreeSelectCustomInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__